import { Link } from "react-router-dom";
import LegalDocumentPage from "./LegalDocumentPage";
import { LEGAL_OPERATOR } from "../content/legalMeta";
import { RULES_LINKS, SERVICE_RULES } from "../content/serviceRules";

export default function Rules() {
  return (
    <LegalDocumentPage
      title="Правила сервиса"
      subtitle="Условия использования платформы MOGAME"
      heroLead={
        <>
          Настоящие Правила определяют порядок работы с платформой для
          создания интерактивных сценариев в Telegram. Используя сервис, вы
          подтверждаете согласие с Правилами,{" "}
          <Link to="/oferta">Публичной офертой</Link> и{" "}
          <Link to="/politic-confidencial">Политикой конфиденциальности</Link>
          .
        </>
      }
      sections={SERVICE_RULES}
      footerLinks={RULES_LINKS}
      footerNote={
        <>
          По вопросам персональных данных, оплаты и модерации:{" "}
          <a href={`mailto:${LEGAL_OPERATOR.email}`}>{LEGAL_OPERATOR.email}</a>
          {" · "}
          <a
            href={LEGAL_OPERATOR.telegramUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {LEGAL_OPERATOR.telegram}
          </a>
        </>
      }
    />
  );
}
